// extracted by mini-css-extract-plugin
module.exports = {"row":"SsFullscreen_row__19Pmj"};